import useFirestoreSubscribe from '@paperstac/common/lib/hooks/useFirestoreSubscribe';
import PropTypes from 'prop-types';
import React from 'react';
import { IdentityContext } from '@paperstac/common/lib/components/IdentityProvider';
import { firestore } from '../../../services/firebaseClient';

export const getIntegrationLogo = (type) => {
  const map = {
    FCI: 'https://res.cloudinary.com/paperstac/image/upload/v1698255867/website-assets/fci.png',
    YOUR_LAND_LOANS: 'https://res.cloudinary.com/paperstac/image/upload/v1722605290/website-assets/your-land-loans.png',
  };
  return map[type] || 'Unknown Servicer';
};

export const getIntegrationName = (type) => {
  const map = {
    FCI: 'FCI Lender Services',
    YOUR_LAND_LOANS: 'Your Land Loans Servicing',
  };
  return map[type] || 'Unknown Servicer';
};

export const isServicerIntegration = (integration) => {
  return ['FCI', 'YOUR_LAND_LOANS'].includes(integration.type);
};

const IntegrationsPageContext = React.createContext();
const { Provider } = IntegrationsPageContext;

const IntegrationsPageProvider = React.memo(({ children }) => {
  const { uid } = React.useContext(IdentityContext);
  const [integrations] = useFirestoreSubscribe(firestore.collection('integrations').where('identityId', '==', uid), [
    uid,
  ]);

  const providerValue = React.useMemo(() => ({ integrations }), [integrations]);

  return <Provider value={providerValue}>{children}</Provider>;
});

IntegrationsPageProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

IntegrationsPageProvider.defaultProps = {};

IntegrationsPageProvider.displayName = 'IntegrationsPageProvider';

export default IntegrationsPageProvider;

export { IntegrationsPageContext };
